import { z } from "zod";

export const columnFilterSchema = z
  .array(
    z.object({
      id: z.string(),
      value: z.object({
        op: z.string(),
        value: z.unknown(),
      }),
    }),
  )
  .optional();
